// Body of the Oscar account order-detail view: the legacy sealy orders page
// -- the "Your Account / Your Orders / {number}" breadcrumbs, the "Order:
// {number}" heading, the shared RichOrderDetail block (typed-serialized
// server-side), and the customer-service info block. The order-details toggle
// is owned by the shared block's own disclosure state (collapsible).
import { Immutable } from "immer";
import React from "react";
import { RichOrderDetail } from "tsi-common-react/src/apps/customer-account/RichOrderDetail/index";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { AccountBreadcrumbs } from "../AccountBreadcrumbs";
import { CustomerServiceInfoBlock } from "../CustomerServiceInfoBlock";

import orderListStyles from "../../styles/composable/order-list.module.scss";

type IProps = Immutable<templates.OrderDetailDocumentTemplate>;

export const OrderDetailPageBody = (props: IProps): React.JSX.Element => {
    return (
        <>
            <div
                className={concatClassNames([
                    "l-capped-width",
                    "u-margin-bottom--xl",
                    "u-full-width-title",
                    orderListStyles.orderList,
                ])}
                data-testid="order-list"
            >
                <AccountBreadcrumbs
                    crumbs={[
                        { label: "Your Account", href: props.profile_url },
                        { label: "Your Orders", href: props.order_list_url },
                        { label: props.order_number },
                    ]}
                />

                <h2>Order: {props.order_number}</h2>

                <div
                    className={concatClassNames([
                        "content__copy--full-width",
                        orderListStyles.ordersContent,
                    ])}
                    data-testid="order-list-content"
                >
                    <div className={orderListStyles.orders}>
                        <ul className={orderListStyles.ordersList}>
                            <li
                                className={orderListStyles.ordersListItem}
                                data-testid="order-list-item"
                            >
                                <div
                                    className={concatClassNames([
                                        "content__copy--full-width",
                                        orderListStyles.orderSummaryWrapper,
                                    ])}
                                >
                                    {/* rich_order_detail is the sealy shape;
                                        the shared template types it nullable
                                        (other sites render order_detail), but
                                        on sealy it is always populated. */}
                                    {props.rich_order_detail && (
                                        <RichOrderDetail
                                            {...props.rich_order_detail}
                                            collapsible={true}
                                        />
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
        </>
    );
};
